import stateExtender from '@/store/utils/stateExtender';
import RepositoryFactory from '@/services/repository-factory';
import datatableModule from '@/store/builder/datatableModule';
import table from '@/components/builders/configs/tables/pagesTable';
import filters from '@/components/builders/configs/filters/pagesFilters';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import editorDialog from './submodules/editorDialog';

const menuGeneralRepository = RepositoryFactory.get('pages');
const state = {
  repository: menuGeneralRepository,
  error: null,
};

export default stateExtender({
  namespaced: true,
  state: () => state,
  modules: {
    table: datatableModule({
      fetch: menuGeneralRepository.table,
      headers: table.headers.filter((header) => header.isShown),
      allHeaders: table.headers,
      options: {
        sortBy: ['pageId'],
        sortDesc: [true],
        itemsPerPage: 15,
      },
      search: filters,
    }),
    editorDialog,
  },
  getters,
  mutations,
  actions,
});
